import ComponentLayout from '~/src/layouts/component-layout';
import { Text, Note } from '@primer/react';
import { Link as GatsbyLink } from 'gatsby';
import { AccessibilityLink } from '~/src/components/accessibility-link';
import * as React from 'react';
export default {
  ComponentLayout,
  Text,
  Note,
  GatsbyLink,
  AccessibilityLink,
  React
};